export default "__VITE_ASSET__BoPfzYyp__"